export default __webpack_public_path__ + "static/media/table_En.33dc39cf.webp";